module.exports = __webpack_public_path__ + "img/11.52d113c6.jpg";